import { t } from "../../../services/utils";
import React from "react";
import { primaryDark10 } from "../../../constants/colors";
class Divider extends React.Component {
  constructor(props) {
    super(props);
  }
  render = () => {
    let styles = {
      container: {
        paddingTop: this.props.paddingTop ? this.props.paddingTop : 0,
        paddingBottom: this.props.paddingBottom ? this.props.paddingBottom : 0,
        backgroundColor: "white",
      },
      divider: {
        height: 1,
        backgroundColor: "#EAE9EF",
        marginLeft: this.props.indent ? 10 : 16,
        marginRight: this.props.indent ? 10 : 16,
      },
    };
    return (
      <div style={styles.container}>
        <div style={styles.divider} />
      </div>
    );
  };
  static getHeight(props) {
    let height = 1;
    if (props.paddingTop) {
      height += props.paddingTop;
    }
    if (props.paddingBottom) {
      height += props.paddingBottom;
    }
    return height;
  }
}
export default Divider;
